import { getSelectedModelsCommand } from '@blocksuite/affine-shared/commands';
import { TelemetryProvider } from '@blocksuite/affine-shared/services';
import { isInsideBlockByFlavour } from '@blocksuite/affine-shared/utils';
import type { SlashMenuConfig } from '@blocksuite/affine-widget-slash-menu';
import { TableIcon } from '@blocksuite/icons/lit';

import { insertTableBlockCommand } from '../commands';
import { tableTooltip } from './tooltips';

export const tableSlashMenuConfig: SlashMenuConfig = {
  disableWhen: ({ model }) => model.flavour === 'affine:table',
  items: [
    {
      name: 'Table',
      description: 'Create a simple table.',
      /*
       * pt-BR — e este bloco PRECISA de apelido tanto quanto o vizinho, por um motivo que não
       * é de tradução (card 1851768965949294521).
       *
       * ⚠️ Este é o `affine:table`, a tabela de **FORMATAÇÃO**: texto arrumado numa grade, sem
       * tipo, sem soma, sem filtro, sem fórmula, e que **não serve de fonte para gráfico**. O
       * vizinho do grupo `Database` é outro bloco inteiro. O doc `🛠️ Como isto foi montado`
       * chama a confusão entre os dois de *"armadilha de adoção número um"* — montar o
       * financeiro nesta aqui funciona por duas semanas e depois não dá para fazer nada com o
       * dado.
       *
       * Deixar só o vizinho com apelido pt-BR fazia `/tabela` levar sempre ao banco de dados e
       * ESTE sumir da busca — escondendo a distinção em vez de mostrá-la. Com `tabela` nos
       * dois (aqui seco, lá como `tabela de dados`), quem digita vê os DOIS, cada um no seu
       * grupo, e escolhe sabendo que há escolha.
       */
      searchAlias: [
        'tabela', 'tabela simples', 'grade', 'formatacao', 'formatação', 'quadro comparativo',
      ],
      icon: TableIcon(),
      tooltip: {
        figure: tableTooltip,
        caption: 'Table',
      },
      group: '4_Content & Media@0',
      when: ({ model }) =>
        !isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text'),
      action: ({ std }) => {
        std.command
          .chain()
          .pipe(getSelectedModelsCommand)
          .pipe(insertTableBlockCommand, {
            place: 'after',
            removeEmptyLine: true,
          })
          .pipe(({ insertedTableBlockId }) => {
            if (insertedTableBlockId) {
              const telemetry = std.getOptional(TelemetryProvider);
              telemetry?.track('BlockCreated', {
                blockType: 'affine:table',
              });
            }
          })
          .run();
      },
    },
  ],
};
